/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Formatting_TitleInputs */



/**
* | output |
* | --- |
* | "Display Formatting" |
*
* @param {Options_Display_Formatting_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_formatting_title = /** @type {((inputs?: Options_Display_Formatting_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Formatting_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise en forme de l'affichage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzeigeformatierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione dello schermo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форматирование отображения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato de visualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示フォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिस्प्ले फ़ॉर्मेटिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação de exibição")
	return /** @type {LocalizedString} */ ("Display Formatting")
});